import { Controller } from '@hotwired/stimulus';
import SET_MAP from '../config/mapbox/setMap';

export default class extends Controller {
  static targets = ['geocoder']

  static values = {
    publicKey: String,
    style: String,
    coordinatesWithPanels: Array
  }

  connect() {
    this.FranceLng = 2.470180
    this.FranceLat = 46.630349
    this.handleMapSettings();
    this.addMarkers();
  }

  handleMapSettings() {    
    this.adminPanelsMap = SET_MAP.initMap(this.publicKeyValue, [this.FranceLng, this.FranceLat], 5, this.styleValue, 'admin-map-panels')
    
    this.geocoder = SET_MAP.initGeocoder('address,place,locality,district,postcode')
    this.adminPanelsMap.addControl(this.geocoder);
  }

  addMarkers() {    
    this.coordinatesWithPanelsValue.forEach(point => {      
      const divEl = document.createElement('div');
      divEl.classList.add('hosman-marker', 'pointer-cursor');

      divEl.addEventListener('click', () => {
        window.open(point.link_url, '_blank');
      });

      const popup = new mapboxgl.Popup({
        offset: 30,
        closeButton: false,
        closeOnClick: false
      }).setHTML(`
        <p class='vesta-card vesta-padding-10 vesta-blue-100'>${point.address}</p>
      `);

      new mapboxgl.Marker(divEl)
        .setLngLat({ lat: point.lat, lng: point.lng })
        .addTo(this.adminPanelsMap);

      divEl.addEventListener('mouseenter', () => {
        popup.setLngLat([point.lng, point.lat]).addTo(this.adminPanelsMap);
      });
  
      divEl.addEventListener('mouseleave', () => {
        popup.remove();
      });
    })
  }
}
